import React from 'react'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

import {
    COLOR
} from '../../../business-const/Color/Color'

import {
    arraySubtrai,
    arrayAte,
} from '../../../business-components/Array/Array'

import {
    GridContainer,
    GridItem11,
    GridItem12,
} from '../../../business-components/Grid/Grid'

import {
    ChartPadrao
} from '../../../business-components/Chart/Chart'

import {
    relatorioModoApresentacao,
} from '../estudo-form/EstudoService'

import {
    aplicarInflacaoCarteiraInvestimentos
} from '../estudo-form/EstudoServiceMatematicaFinanceira'

import {
    CardGridEstudoPadrao,
} from '../estudo-form/EstudoComp'



const AnalisePrevidenciaPrivadaVersusSeguroVidaInteiraChart = ( { values, estudo, estrategiasFinanceirasTabelaEvolucaoValorResgate, report } ) => {

    const TabelaEvolucaoValorResgate = () => {

        const series = []

        const paletaCoresEspecifica = []

        const valorCS = []

        const indAte =
            values.anosLimitarQtdeAnosExibidosGraficosTabelasEvolucao
                ?
                   values.anosLimitarQtdeAnosExibidosGraficosTabelasEvolucao - 1
                :
                    null



        const graficoRecursosFinanceirosAcumuladosPrevidenciaPrivada = aplicarInflacaoCarteiraInvestimentos(values, estudo,
            estudo.current.graficoRecursosFinanceirosAcumuladosPrevidenciaPrivada, 0,
                values.aplicarTaxaInflacaoTabelaEvolucaoValorResgate)

        const graficoRecursosFinanceirosAcumuladosPrevidenciaPrivadaMenosDifPremioAnualizadoBruto = []

        graficoRecursosFinanceirosAcumuladosPrevidenciaPrivada?.forEach( (linha, ind) => {

            graficoRecursosFinanceirosAcumuladosPrevidenciaPrivadaMenosDifPremioAnualizadoBruto.push(linha -
                (estrategiasFinanceirasTabelaEvolucaoValorResgate.graficoInvestimentoPremioAnualizadoBruto[ind] -
                    estrategiasFinanceirasTabelaEvolucaoValorResgate.graficoInvestimentoPremioAnualizado[ind]))
        })

        series.push(
            {
                name: LABEL.previdenciaPrivada,
                type: 'area',
                data: arrayAte(graficoRecursosFinanceirosAcumuladosPrevidenciaPrivadaMenosDifPremioAnualizadoBruto, indAte),
            },
        )

        paletaCoresEspecifica.push(
            COLOR().corChartPadraoVerde
        )

        
        
        const graficoPrevidenciaPrivadaMenosPremioAnualizadoBruto =
            arraySubtrai(graficoRecursosFinanceirosAcumuladosPrevidenciaPrivada,
                estrategiasFinanceirasTabelaEvolucaoValorResgate.graficoInvestimentoPremioAnualizadoBruto)

        series.push(
            {
                name: LABEL.previdenciaPrivada + ' - ' + LABEL.premio,
                type: 'line',
                data: arrayAte(graficoPrevidenciaPrivadaMenosPremioAnualizadoBruto, indAte),
            },
        )

        paletaCoresEspecifica.push(
            COLOR().corChartPadraoValorPremioAnualizadoAcumulado
        )



        //const graficoPrevidenciaPrivadaMenosPremioAnualizado =
        //    arraySubtrai(graficoRecursosFinanceirosAcumuladosPrevidenciaPrivada,
        //        estrategiasFinanceirasTabelaEvolucaoValorResgate.graficoInvestimentoPremioAnualizado)

        estrategiasFinanceirasTabelaEvolucaoValorResgate.tabelaEvolucaoValorResgate?.forEach( (linha, ind) => {
            
            if (ind === 0 && linha.ano !== 0) {
                
                valorCS.push(linha.valorCS)
            }

            valorCS.push(linha.valorCS)
        })

        const graficoPrevidenciaPrivadaMenosPremioAnualizadoMaisValorCS = []

        graficoPrevidenciaPrivadaMenosPremioAnualizadoBruto/**/?.forEach( (linha, ind) => {

            graficoPrevidenciaPrivadaMenosPremioAnualizadoMaisValorCS.push(
                linha + valorCS[ind]
            )
        })

        series.push(
            {
                name: LABEL.previdenciaPrivada + ' - ' + LABEL.premio + ' + ' + LABEL.vidaInteira,
                type: 'line',
                data: arrayAte(graficoPrevidenciaPrivadaMenosPremioAnualizadoMaisValorCS, indAte),
            },
        )

        paletaCoresEspecifica.push(
            COLOR().corChartPadraoPrevidenciaPrivadaPremioVidaInteira
        )



        let categories = [...estudo.current.graficoIdades]

        if (estrategiasFinanceirasTabelaEvolucaoValorResgate.familiar === HARDCODE.idFamiliarConjuge) {

            categories?.forEach( (linha, ind) => {

                categories[ind] += values.idadeDataSimulacaoConjuge - values.idadeDataSimulacaoCliente
            })
        }

        categories = arrayAte(categories, indAte)
        const categories2 = arrayAte(estudo.current.graficoAnos, indAte)



        return (
            <GridContainer>
                <GridItem11
                    //className='ml-10 mt--8'
                >
                    <ChartPadrao
                        titleText={''}
                        type={'line'}
                        series={series}
                        height={report ? 400 : 550}
                        stacked={false}
                        categories={categories}
                        categories2={categories2}
                        paletaCores={paletaCoresEspecifica}
                        dataLabelsEnabled={true}
                        dataLabelsEnabledReport={true}
                        dataLabelsType='IdadeIndex'
                        dataLabelsDestaque={
                            estrategiasFinanceirasTabelaEvolucaoValorResgate.tabelaEvolucaoValorResgate[4].bold
                                ?
                                    [categories[5]]
                                :
                                    ''
                        /*[values.idadeDataSimulacaoCliente + 10]*/}
                        notInverseOrder={true}
                        //legendFixedEnabled={true}
                        toolTipX={true}
                        toolTipXTotal={false}
                        report={report}
                        formatoReport={values.formatoReport}
                        fillOpacity={0.8}
                    />
                </GridItem11>
            </GridContainer>
        )
    }

    return (
        <GridItem12>
            {report
                ?
                    <TabelaEvolucaoValorResgate
                        //className={popup ? 'mt-20' : simulacaoFinanceira ? 'mt-5' : 'mt--5 ml-3' /* mudança da fonte: mt-3 */}
                    />
                :
                    <CardGridEstudoPadrao
                        label={
                            !relatorioModoApresentacao(values)
                                ?
                                    LABEL.analisePrevidênciaPrivadaVersusSeguroVidaInteira + ': ' +
                                        estrategiasFinanceirasTabelaEvolucaoValorResgate.nomeFamiliar
                                :
                                    HARDCODE.modoApresentacaoRelatorio
                        }
                        component={
                            <div
                                className='ml-10'
                            >
                                <TabelaEvolucaoValorResgate/>
                            </div>
                        }
                        overflowX={false}
                    />
            }
        </GridItem12>
    )
}

export default AnalisePrevidenciaPrivadaVersusSeguroVidaInteiraChart